import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_price_before_scratch_new_funnels~1
		female: {
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_price_before_scratch_new_funnels/fasting-weekly'
					),
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_price_before_scratch_new_funnels~1
		'female-water-fasting': {
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_price_before_scratch_new_funnels/fasting-weekly'
					),
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-hashimoto-diet&exp=web_price_before_scratch_new_funnels~1
		'female-hashimoto-diet': {
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_price_before_scratch_new_funnels/fasting-weekly'
					),
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_price_before_scratch_new_funnels~1
		'activity-male-tai-chi-yoga-pr': {
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_price_before_scratch_new_funnels/tai-chi-male'
					),
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_price_before_scratch_new_funnels~1
		'activity-male-chair-tai-chi': {
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_price_before_scratch_new_funnels/tai-chi-male'
					),
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_price_before_scratch_new_funnels~1
		'activity-male-chair-tai-chi-al': {
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_price_before_scratch_new_funnels/tai-chi-male'
					),
			},
		},
	},
]

export default config
